export default __webpack_public_path__ + "static/media/team_rith.b8e48fd7.png";